import { type TableFilterDefinition } from "@ds/components/table-filters";

import { playersService } from "../utils/api";
import { PlayerStateEnum } from "../utils/model";

export const PLAYER_TABLE_FILTERS: TableFilterDefinition[] = [
  {
    field: "state",
    label: "Status",
    kind: "select",
    options: [
      { value: PlayerStateEnum.Online, label: "Online" },
      { value: PlayerStateEnum.Offline, label: "Offline" },
      { value: PlayerStateEnum.Paired, label: "Paired" },
      { value: PlayerStateEnum.Unpaired, label: "Unpaired" },
    ],
  },
  {
    field: "model",
    label: "Model",
    kind: "remote-select",
    fetchOptions: () => playersService.getPlayerValues("model"),
  },
  {
    field: "code_version",
    label: "Code version",
    kind: "remote-select",
    fetchOptions: () => playersService.getPlayerValues("code_version"),
  },
  {
    field: "os_version",
    label: "OS version",
    kind: "remote-select",
    fetchOptions: () => playersService.getPlayerValues("os_version"),
  },
];
